import React, { useEffect } from "react";
import { Box, Fade } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LHSNavigation from "components/LHS";

// redux
import api from "utils/api";
import { set_user } from "store/reducers/userSlice";
import { useSelector } from "react-redux";
import LoadingSpinner from "../LoadingSpinner";
import { useAppDispatch } from "store/store";

interface Props {
  children: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  let navigation = useNavigate();
  let user = useSelector((state: any) => state.users.user);
  const dispatch = useAppDispatch();

  useEffect(() => {
    api
      .getUser()
      .then((res) => {
        if (res.status === 200) {
          if (res.data !== "") {
            if (
              res.data.permissions.includes("super-admin") ||
              res.data.permissions.includes("brand-site.enabled")
            ) {
              dispatch(set_user(res.data));
              localStorage.setItem("user", JSON.stringify(res.data));
            } else {
              window.open(process.env.REACT_APP_PUBLIC_URL + "/media", "_self");
            }
          } else {
            set_user(null);
            window.open(process.env.REACT_APP_LOGIN_URL, "_self");
          }
        }
      })
      .catch((err) => {
        dispatch(set_user(null));
        console.log("[ERR]: ", err);
        window.open(process.env.REACT_APP_LOGIN_URL, "_self");
      });

    window.scrollTo({
      top: 0,
    });
  }, [navigation, dispatch]);

  return user ? (
    <Fade in={!!user} timeout={500} data-testid="layout">
      <Box sx={{ display: "flex" }} flex={1}>
        <LHSNavigation/>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: 3,
            pl: 5,
          }}
        >
          {children}
        </Box>
      </Box>
    </Fade>
  ) : (
    <LoadingSpinner />
  );
};

export default Layout;
